import { Icon } from '@vst/beam';
import { Close, Menu } from '@vst/beam-icons/icons';

import styles from './styles.module.scss';

const HamburgerMenuButton = ({
  isOpen,
  onClick,
}: {
  isOpen: boolean;
  onClick: () => void;
}) => {
  const icon = isOpen ? Close : Menu;

  return (
    <div
      className={styles.hamburgerButton}
      onClick={onClick}
      data-cy="mobileMenuToggle"
    >
      <Icon icon={icon} size={28} mr="8px" />
    </div>
  );
};

export default HamburgerMenuButton;
